<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Edit Sales channel</h2>
        </div>
        <div slot="body">
            <div class="col-sm-12 py-3">
                <sales-channel-form :salesChannel="tempSalesChannel"></sales-channel-form>
                <!-- <div class="d-flex justify-content-end">
                    <button class="btn action" @click="deleteChannel(tempSalesChannel)">Delete</button>
                </div> -->
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import salesChannelForm from './salesChannelForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                tempSalesChannel: null
            }
        },
        created: function() {
            this.tempSalesChannel = JSON.parse(JSON.stringify(this.getSelectedSalesChannel))
        },
        computed: {
            ...mapGetters([
                'getSelectedSalesChannel'
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'setSelectedSalesChannel',
                'deleteSalesChannel',
                'updateSalesChannel',
                'downloadSalesChannels'
            ]),
            deleteChannel: function(salesChannel) {
                this.deleteSalesChannel(salesChannel)
            },
            save: function() {
                this.updateSalesChannel(this.tempSalesChannel).then(success => {
                    if(success == true){
                        this.closeModal();
                        this.downloadSalesChannels();
                    }
                })
            },
            close: function() {
                this.setSelectedSalesChannel(null)
                this.closeModal();
            },
        },
        components: {
            Modal,
            salesChannelForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// editSalesChannel.vue?4b46c04c